import PreviewSharpIcon from '@mui/icons-material/PreviewSharp';
import { IconButton, Tooltip } from '@mui/material';
import { openUrlInNewTab } from '@utils/urls';
import { FunctionComponent } from 'react';

export type PreviewLinkButtonProps = {
  url: string;
};

export const PreviewLinkButton: FunctionComponent<PreviewLinkButtonProps> = (
  props,
) => {
  const { url } = props;
  return (
    <Tooltip title="Preview external link">
      <IconButton onClick={() => openUrlInNewTab(url)}>
        <PreviewSharpIcon />
      </IconButton>
    </Tooltip>
  );
};
